import { Side } from '@/compiled_proto/com/celertech/marketdata/api/enums/SideProto';
import { UseCurrencyReturn } from '@/utils/hooks/useCurrency';
import { getLanguage } from '@/utils/hooks/useLanguage';

interface OrderMessageParams {
    side: Side;
    isCcy2Order: boolean;
    ccy1Config: UseCurrencyReturn;
    ccy2Config: UseCurrencyReturn;
}
export function formatOrderMessage({ side, isCcy2Order, ccy1Config, ccy2Config }: OrderMessageParams) {
    const lang = getLanguage();

    const lowerSide = Side[side].toLowerCase();
    const lowerOtherSide = Side[side === 1 ? 2 : 1].toLowerCase();

    if (!isCcy2Order) {
        return `${lang.orderForm[lowerSide]} ${ccy1Config.show} / ${lang.orderForm[lowerOtherSide]} ${ccy2Config.show}`;
    } else {
        return `${lang.orderForm[lowerSide]} ${ccy2Config.show} / ${lang.orderForm[lowerOtherSide]} ${ccy1Config.show}`;
    }
}
